
    export default {
      mounted() {
        const label = this.el.innerText;

        this.el.addEventListener("click", () => {
          const source = document.querySelector(this.el.dataset.copyTarget);
          if (!source || !navigator.clipboard) return;

          navigator.clipboard
            .writeText(source.value)
            .then(() => { this.el.innerText = "Copied"; })
            .catch(() => { this.el.innerText = "Copy failed"; })
            .finally(() => {
              clearTimeout(this.reset);
              this.reset = setTimeout(() => { this.el.innerText = label; }, 1500);
            });
        });
      }
    };
  